module.exports = __webpack_public_path__ + "media/images/railsway-83e2f981a116db3a98e8edeb57561b49.png";